import { useQuery } from 'react-query';

import { useAuth0 } from '@auth0/auth0-react';
import setToken from '../../utils/api';
import { IThunderbirdOrderFull } from '../../types/IThunderbirdOrderResponse';

export default function useThunderbirdOrderDetails(id: number | undefined) {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<IThunderbirdOrderFull, IThunderbirdOrderFull, any>(
    ['thunderbird-order-details', id],
    async () => {
      const token = await getAccessTokenSilently();
      const api = await setToken(token);
      const response = await api.get<IThunderbirdOrderFull>(
        `api/thunderbird-orders/${id}`,
        {},
      );

      if (response?.status !== 200) {
        throw new Error(`Couldn't find thunderbird order`);
      }

      return response.data;
    },
    {
      enabled: !!id,
      refetchOnWindowFocus: false,
    },
  );
}
